import { render, staticRenderFns } from "./goodsBoxCell.vue?vue&type=template&id=7f7dd884&scoped=true"
import script from "./goodsBoxCell.vue?vue&type=script&lang=js"
export * from "./goodsBoxCell.vue?vue&type=script&lang=js"
import style0 from "./goodsBoxCell.vue?vue&type=style&index=0&id=7f7dd884&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7dd884",
  null
  
)

export default component.exports